export const API_URL = 'https://api-v2.gip.su';